import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { transformDates } from './axiosDateTransformer'

axios.defaults.timeout = 180000
const apiClient = axios.create({
  timeout: 180000,
})

if (import.meta.env.VITE_ENVIRONMENT === 'development') {
  console.debug('Development mode: Adding artificial delay to API requests')
  // Add artificial delay to simulate network latency
  apiClient.interceptors.response.use(async (response) => {
    // Generate random delay between 0.1 and 1 seconds
    const delay = Math.random() * 600 + 50
    await new Promise((resolve) => setTimeout(resolve, delay))
    return response
  })
}

addAuthInterceptor(apiClient)
addAuthInterceptor(axios)

// Add date transformation interceptor
apiClient.interceptors.response.use((response) => transformDates(response))

export default apiClient

let interceptorLogoutCallback: (() => void) | null = null
export const setInterceptorLogoutCallback = (callback: () => void): void => {
  interceptorLogoutCallback = callback
}

function addAuthInterceptor(axiosInstance: AxiosInstance) {
  // Add auth interceptor
  axiosInstance.interceptors.response.use((response) => response, (error) => {
    if (error.response?.status === 401) {
      console.debug('Unauthorized access - logging out')
      interceptorLogoutCallback?.()
    }

    return Promise.reject(error)
  })
}